import { FC } from "react";
import { clsx } from "clsx";
import { User } from "../../types/UserGroup";
import { useUsers } from "../useUsers";
import styles from "./UserList.module.less";

export interface UserListProps {
    selectedId?: number;
    onSelect: (user: User) => void;
    /** Narrows the list to the users whose name or email contains it. */
    query: string;
}

/** The org's users as a pickable list, the selected one highlighted. */
export const UserList: FC<UserListProps> = ({ selectedId, onSelect, query }) => {
    const users = useUsers();
    const q = query.trim().toLowerCase();
    const hits = (users ?? []).filter(
        (u) => !q || u.name.toLowerCase().includes(q) || u.email?.toLowerCase().includes(q)
    );
    return (
        <ul className={styles.list} role="listbox">
            {!users && <li className={styles.empty}>Loading…</li>}
            {users && hits.length === 0 && (
                <li className={styles.empty}>
                    {q ? `No one matches “${query.trim()}”.` : "No users."}
                </li>
            )}
            {hits.map((u) => (
                <li
                    key={u.id}
                    role="option"
                    aria-selected={u.id === selectedId}
                    className={clsx(styles.option, u.id === selectedId && styles["option--selected"])}
                    onClick={() => onSelect(u)}
                >
                    <span className={styles.optionName}>{u.name}</span>
                    <span className={styles.optionEmail}>{u.email}</span>
                </li>
            ))}
        </ul>
    );
};
